import React, {Component} from 'react'

export default class WynajemGaleria extends Component {

    constructor(props) {
        super(props)

        this.state = {
            images: [],
            imgCount: 0
        }
    }


    componentDidMount(){
        const r = require.context(
            "../../../img/wynajem/",
            false,
            /\.(png|jpe?g|svg)$/
        );
        let importedImages = []
        let i=0;
        r.keys().forEach(item => {
            const importedImg = r(item);
            importedImages.push(importedImg);
        });
        this.setState({images: importedImages});
    }

    render() {
        return <div>
            <div id="wynajemGaleria" className="carousel slide" data-ride="carousel" data-interval="4000">
                <div className="carousel-inner">
                    {this.state.images.map((item, index) => {
                        if (index === 0){
                            console.log('test')
                            return  <div className="carousel-item active">
                                <img className="d-block w-100"
                                     src={item}
                                     alt="Slajd"/>
                            </div>
                        } else {
                            return  <div className="carousel-item">
                                <img className="d-block w-100"
                                     src={item}
                                     alt="Slajd"/>
                            </div>
                        }
                    })}
                </div>
                <a className="carousel-control-prev" href="#wynajemGaleria" data-slide="prev">
                    <span className="carousel-control-prev-icon"></span>
                </a>
                <a className="carousel-control-next" href="#wynajemGaleria" data-slide="next">
                    <span className="carousel-control-next-icon"></span>
                </a>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/wynajemComponents/WynajemGaleria.js